import isEqual from "lodash-es/isEqual";

export function getUndef<T>(func: () => T): T | null {
  try {
    return func();
  } catch (error) {
    return null;
  }
}

type DataFromItems = {
  lineItems: {
    create: any[];
    update: any[];
    delete: any[];
  };
};
export function getDataFromItemsToChange(
  itemsToChange,
  checkout
): DataFromItems {
  const toCreate = [];
  const toUpdate = [];
  const toDelete = [];

  itemsToChange.forEach(({ id, ingredients, quantity }) => {
    const itemInCheckout = getUndef(() =>
      checkout.lineItems.find((i) => {
        const itemIngredients = getIngredients(i.customAttributes);
        return i.variant.id === id && isEqual(itemIngredients, ingredients);
      })
    );

    const itemInCheckoutQuantity = itemInCheckout ? itemInCheckout.quantity : 0;
    const newQuantity = quantity + itemInCheckoutQuantity;

    if (itemInCheckoutQuantity === newQuantity) {
      return;
    }

    if (newQuantity <= 0 && itemInCheckout) {
      toDelete.push({
        id: itemInCheckout.id,
      });
    } else if (newQuantity >= 1 && !itemInCheckout) {
      toCreate.push({
        quantity: newQuantity,
        variant: {
          connect: {
            id,
          },
        },
        customAttributes: {
          create: formatIngredients(ingredients),
        },
      });
    } else if (newQuantity >= 1 && itemInCheckout) {
      toUpdate.push({
        where: {
          id: itemInCheckout.id,
        },
        data: {
          quantity: newQuantity,
        },
      });
    }
  });

  return {
    lineItems: {
      create: toCreate,
      update: toUpdate,
      delete: toDelete,
    },
  };
}

function formatIngredients(
  ingredients?: {
    id: string;
    name: string;
    amount: number;
  }[]
): {
  key: string;
  value: string;
}[] {
  if (!ingredients || !ingredients.length) {
    return [];
  }
  return ingredients.map(({ id, name, amount }) => ({
    key: "ingredient",
    value: `${id}_${name}_${amount}`,
  }));
}

export function getIngredients(
  ingredients: {
    key: string;
    value: string;
  }[]
): {
  id: string;
  name: string;
  amount: number;
}[] {
  return ingredients.map(({ value }) => {
    const [id, name, amount] = value.split("_");
    return {
      id,
      name,
      amount: +amount,
    };
  });
}

export function getOptimisticResults(toChange: any, buffer: Array<any>) {
  const bufferAccumed = buffer
    .map((i) => i.action)
    .reduce((acc, val) => {
      return addObjs(acc, val);
    }, {});

  let result = bufferAccumed;

  const toChangeIsNotEmpty = Object.keys(toChange).filter(
    (key) => key !== "_id"
  ).length;
  const toChangeIsInBuffer = buffer.find((i) => i.id === toChange._id);
  if (toChangeIsNotEmpty && !toChangeIsInBuffer) {
    result = addObjs(bufferAccumed, toChange);
  }
  delete result._id;
  return result;
}

function addObjs(obj1, obj2) {
  const resultItems = obj1.items ? [...obj1.items] : [];

  obj2.items.map((item) => {
    const inResultIndex = resultItems.findIndex(
      (i) => i.id === item.id && isEqual(i.ingredients, item.ingredients)
    );
    if (inResultIndex >= 0) {
      resultItems[inResultIndex] = {
        ...resultItems[inResultIndex],
        quantity: resultItems[inResultIndex].quantity + item.quantity,
      };
    } else {
      resultItems.push(item);
    }
  });
  return { ...obj1, items: resultItems };
}
